var map = {
	"./abac-nestjs.jpg": 963,
	"./avatar.png": 403,
	"./beach.gif": 468,
	"./character03.gif": 491,
	"./ems-dashboard.png": 472,
	"./ems.jpg": 867,
	"./en_flag.png": 644,
	"./files/CV_NguyenTanLoc.pdf": 961,
	"./files/CV_NguyenTanLoc_2025.pdf": 593,
	"./fonts/AlumniSans-Medium.woff": 230,
	"./fonts/Handjet-Bold.ttf": 237,
	"./fonts/Handjet-Regular.ttf": 572,
	"./fonts/JetBrainsMono-Medium.ttf": 716,
	"./fonts/Lemonada-Medium.woff": 150,
	"./fonts/rainyhearts.ttf": 911,
	"./hicoffee-management.jpg": 577,
	"./hicoffee-mobile.jpg": 629,
	"./labs-app.jpg": 818,
	"./labs.jpg": 772,
	"./link.png": 76,
	"./pointer.png": 561,
	"./stars.gif": 994,
	"./teknix.svg": 189,
	"./typing.gif": 186,
	"./viet247-logo.png": 319,
	"./vn_flag.png": 695,
	"./wallpaper.gif": 83,
	"./windows.gif": 158,
	"./woackwoack.gif": 974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;